import type {
  PresetKey,
  TimeFilter,
} from "@/components/v2/DatePicker/constants";

import { createContext } from "react";
import type { DateRange } from "react-day-picker";

export type IPortfolioPageContext = {
  dateRange?: DateRange;
  datePreset?: PresetKey;
  timeFilter?: TimeFilter;
  comparisonTimeFilter?: TimeFilter;
  // null means "every building"
  selectedBuildingIds: string[] | null;
};

export const PortfolioPageContext = createContext({
  dateRange: undefined,
  datePreset: undefined,
  timeFilter: undefined,
  comparisonTimeFilter: undefined,
  selectedBuildingIds: null,
} as IPortfolioPageContext);
